import React from 'react';
import ReactDOM from 'react-dom';
import * as serviceWorker from './serviceWorker';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware, compose, combineReducers } from 'redux';

import actionsReducer from './store/reducers/FlowActionsReducer';
import adminReducer from './store/reducers/AdminReducer';
import appReducer from './store/reducers/AppReducer';
import articleReducer from './store/reducers/ArticleReducer';
import authReducer from './store/reducers/AuthReducer';
import cartReducer from './store/reducers/CartReducer';
import clipReducer from './store/reducers/ClipReducer';
import clipListReducer from './store/reducers/ClipListReducer';
import commentsReducer from './store/reducers/CommentsReducer';
import crmReducer from './store/reducers/CrmReducer';
import cropReducer from './store/reducers/CropReducer';
import customDataReducer from './store/reducers/CustomDataReducer';
import cutReducer from './store/reducers/CutReducer';
import devicesReducer from './store/reducers/DevicesReducer';
import distributionsReducer from './store/reducers/DistributionsReducer';
import distributionTreeReducer from './store/reducers/DistributionTreeReducer';
import ecommerceReducer from './store/reducers/EcommerceReducer';
import eventRoomTreeReducer from './store/reducers/EventRoomTreeReducer';
import eventRoomsReducer from './store/reducers/EventRoomsReducer';
import flexReducer from './store/reducers/FlexReducer';
import ftvContactsReducer from './store/reducers/FtvContactsReducer';
import mediafileReducer from './store/reducers/MediafileReducer';
import mailingReducer from './store/reducers/MailingReducer';
import metadataReducer from './store/reducers/MetadataReducer';
import newsroomTreeReducer from './store/reducers/NewsroomTreeReducer';
import nlwReducer from './store/reducers/NlwReducer';
import notificationReducer from './store/reducers/NotificationReducer';
import notificationApprovalUserReducer from './store/reducers/NotificationApprovalUserReducer';
import notificationSenderUserReducer from './store/reducers/NotificationSenderUserReducer';
import pmdbReducer from './store/reducers/PmdbReducer';
import profilesReducer from './store/reducers/ProfilesReducer';
import projectsReducer from './store/reducers/ProjectsReducer';
import projectTreeReducer from './store/reducers/ProjectTreeReducer';
import roomsReducer from './store/reducers/RoomsReducer';
import sdkReducer from './store/reducers/SdkReducer';
import searchReducer from './store/reducers/SearchReducer';
import seriesTreeReducer from './store/reducers/SeriesTreeReducer';
import shareReducer from './store/reducers/ShareReducer';
import faceReducer from './store/reducers/FaceReducer';
import aiReducer from './store/reducers/AiReducer';
import sortReducer from './store/reducers/SortReducer';
import storageStateReducer from './store/reducers/StorageStateReducer';
import statisticsReducer from './store/reducers/StatisticsReducer';
import statusBarReducer from './store/reducers/StatusBarReducer';
import tagsReducer from './store/reducers/TagsReducer';
import uiReducer from './store/reducers/UiReducer';
import UploadFilesReducer from './store/reducers/UploadFilesReducer';
import uploadProjectsReducer from './store/reducers/UploadProjectsReducer';
import uploadProjectTreeReducer from './store/reducers/UploadProjectTreeReducer';
import tvTreeReducer from './store/reducers/TvTreeReducer';
import laneTreeReducer from './store/reducers/LaneTreeReducer';
import userReducer from './store/reducers/UserReducer';
import vimeoReducer from './store/reducers/VimeoReducer';
import workReducer from './store/reducers/WorkReducer';
import workflowsReducer from './store/reducers/WorkflowsReducer';
import youtubeReducer from './store/reducers/YoutubeReducer';

import thunk from 'redux-thunk';

export const Components = {};

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const rootReducer = combineReducers({
    admin: adminReducer,
    ai: aiReducer,
    app: appReducer,
    article: articleReducer,
    auth: authReducer,
    cart: cartReducer,
    clip: clipReducer,
    clipList: clipListReducer,
    comment: commentsReducer,
    crm: crmReducer,
    crop: cropReducer,
    customData: customDataReducer,
    cut: cutReducer,
    devices: devicesReducer,
    distributions: distributionsReducer,
    distributionTree: distributionTreeReducer,
    ecommerce: ecommerceReducer,
    face: faceReducer,
    flex: flexReducer,
    flowActions: actionsReducer,
    ftvContacts: ftvContactsReducer,
    laneTree: laneTreeReducer,
    mailing: mailingReducer,
    mediafiles: mediafileReducer,
    metadata: metadataReducer,
    newsroomTree: newsroomTreeReducer,
    nlw: nlwReducer,
    notification: notificationReducer,
    notificationApprovalUser: notificationApprovalUserReducer,
    notificationSenderUser: notificationSenderUserReducer,
    pmdb: pmdbReducer,
    profiles: profilesReducer,
    projects: projectsReducer,
    projectTree: projectTreeReducer,
    rooms: roomsReducer,
    search: searchReducer,
    seriesTree: seriesTreeReducer,
    sdk: sdkReducer,
    share: shareReducer,
    sort: sortReducer,
    statistics: statisticsReducer,
    statusBar: statusBarReducer,
    storageState: storageStateReducer,
    tags: tagsReducer,
    tvTree: tvTreeReducer,
    ui: uiReducer,
    uploadFiles: UploadFilesReducer,
    uploadProjects: uploadProjectsReducer,
    uploadProjectTree: uploadProjectTreeReducer,
    eventRoomTree: eventRoomTreeReducer,
    eventRooms: eventRoomsReducer,
    user: userReducer,
    vimeo: vimeoReducer,
    workflows: workflowsReducer,
    youtube: youtubeReducer
});

const store = createStore(rootReducer, composeEnhancers(
    applyMiddleware(thunk)
));

let state = store.getState();

window.sessionCheck = false;

//console.log("INDEX");

import(`./${process.env.REACT_APP_APPID}/App`).then((Module) => {
    const App = Module.default;
    const app = (
        <Provider store={store}>
            <BrowserRouter basename={process.env.REACT_APP_BASEPATH}>
                <App />
            </BrowserRouter>
        </Provider>
    );

    //ReactDOM.render(<Flow2 />, document.getElementById('root'));
    ReactDOM.render(app, document.getElementById('root'));

    // If you want your app to work offline and load faster, you can change
    // unregister() to register() below. Note this comes with some pitfalls.
    // Learn more about service workers: http://bit.ly/CRA-PWA
    serviceWorker.unregister();

}).catch(e => {
    console.log("HELLO WORLD");
});

export default store;
